export type GoogleReview = {
  name: string;
  month: string;
  year: number;
  text: string;
};

export const GOOGLE_BUSINESS_URL = "https://share.google/3PmD2sCmBLd64qTxa";
export const GOOGLE_AVERAGE_RATING = 4.6;
export const GOOGLE_TOTAL_REVIEWS = 50;

export const TRUSTPILOT_BUSINESS_URL =
  "https://uk.trustpilot.com/review/completeremedialsolutions.co.uk";
export const TRUSTPILOT_AVERAGE_RATING = 4.6;
export const TRUSTPILOT_TOTAL_REVIEWS = 55;

export type TrustpilotReview = {
  name: string;
  month: string;
  year: number;
  title?: string;
  text: string;
};

export const TRUSTPILOT_REVIEWS: TrustpilotReview[] = [
  {
    name: "Paul Bennett",
    month: "July",
    year: 2026,
    title: "A well drilled outfit of tradesmen",
    text: "CRS are a well drilled outfit of tradesmen that all work together to provide the best efficient service under the Government home energy grant system. They were clean, polite and friendly and very efficient. I would highly recommend them.",
  },
  {
    name: "Adrian Cosgrove",
    month: "July",
    year: 2026,
    title: "I can thoroughly recommend CRS",
    text: "I can thoroughly recommend CRS, they fitted a brand new heating system in my house. Nathan and his team were brilliant, the whole job was completed in a day, they cleaned up after themselves, were polite and courteous. Well done boys.",
  },
  {
    name: "Richard Worsnop",
    month: "July",
    year: 2026,
    title: "Best company I've dealt with",
    text: "As a homeowner you often have people in to fix things and I can honestly say this company is exceptional. From the initial approach through to completion everything was carried out in a friendly, respectful and professional way, from the initial survey and admin office through to the fitters who carried out the work. People turned up when they said they would and did the work with skill and efficiency. They were friendly and respectful and tidied up after them. You couldn't ask for more. A model company. Thank You!",
  },
  {
    name: "Frank Ciccotti",
    month: "July",
    year: 2026,
    title: "Highly competent work",
    text: "Highly competent work, from initial design to installation. We had an air source heat pump, solar panels and extensive insulation installed. Large teams of skilled tradespeople arrived in planned succession. Work was completed within agreed timescales. Problems, where they arose, were quickly resolved. They even painted after completing the work!",
  },
  {
    name: "Julia Morgan",
    month: "June",
    year: 2026,
    title: "The team at CRS were helpful from the start",
    text: "The team at CRS were helpful from the start when I received a letter about government funded boiler replacement. Any questions answered, went above and beyond to help me, as my husband had passed away and it was him who dealt with stuff about the house, but the team put me at ease and were so helpful. A very happy customer.",
  },
  {
    name: "Jan",
    month: "June",
    year: 2026,
    title: "Highly recommend CRS",
    text: "Friendly, helpful and knowledgeable office and practical field staff made the whole process easy to understand and navigate from the beginning. On-site workers were hugely respectful of our property and got all jobs completed on exact appointment days and within allocated work times. A great service all round from CRS. Highly recommend.",
  },
  {
    name: "Christina Durbin",
    month: "June",
    year: 2026,
    title: "Efficient installation",
    text: "I had a positive experience with this company. The assessment process took a while but I thought that was a good thing because they were being sure that no mistakes were made. The installation was seamless as was the electrical work to fit extractor fans. I was happy with the administration team and understood what to expect.",
  },
  {
    name: "Neil Springate",
    month: "August",
    year: 2025,
    title: "Highly recommended",
    text: "I highly recommend this company. We had a new boiler, additional loft insulation and extra extraction fans fitted under a government grant scheme. It started with a two-hour survey of the house, then the ball started rolling. Great communication from everyone concerned, the installation coordinator had everything running smoothly. Two fans fitted in a couple of hours, followed three days later by two gents fitting the loft insulation and another two fitting the boiler. Finally two electricians arrived to finish off the installation. Everyone turned up on time, they all worked quickly and cleanly. The whole installation could not have run more smoothly.",
  },
  {
    name: "Bin Li",
    month: "May",
    year: 2026,
    title: "Excellent experience with CRS Energy",
    text: "My recent experience with CRS Energy was excellent. What stood out was the install team, admin staff, scheduling, friendly service, tidy and clean, communication, on time, quality of work, value for money, and how they explained things clearly. Professional and friendly team, excellent work. We can feel warm during the winter. Very satisfied!",
  },
  {
    name: "C Morris",
    month: "May",
    year: 2026,
    title: "Outstanding service",
    text: "Company installed a new boiler for us last year 2025. Gavin and Steve were friendly, polite and professional, they explained everything to put our minds at rest. I would highly recommend this company, outstanding service.",
  },
  {
    name: "Kevin Stevens",
    month: "September",
    year: 2024,
    title: "Very pleased with Complete Remedial Solutions",
    text: "This company carried out the work on our house for a Welsh government grant scheme, the work was carried out between July and September for a new boiler and internal wall and cavity wall insulation. Every one of the workers in the different teams, including the plumbers, electricians, insulation team, carpenters, plasterers, and the painter were all very polite, friendly and respectful of our property. Each team took the time to cover the stair carpet and other surfaces, cleaned up, removed dust sheets and disposed of anything left after finishing. We would highly recommend them.",
  },
  {
    name: "Eurona-Wyn Jones",
    month: "April",
    year: 2024,
    title: "If you want a job done go to CRS",
    text: "I was very impressed by the efficiency of this company from the very beginning. The surveyor was well dressed, very polite and always asked before taking photographs of various parts of my home. The office staff were friendly and always had time for a joke and a laugh but made sure any requests were dealt with. The crew installing the boiler were fantastic, respectful to me and my home. They covered the area with plastic and cleared up beautifully. Well done CRS. I would and will recommend you to anyone.",
  },
  {
    name: "Polly Rubinstein",
    month: "September",
    year: 2023,
    title: "Very helpful, friendly and reliable",
    text: "I used CRS in spring 2023 to do a fairly big retrofit including installing an Air Source Heat Pump, completely new wet central heating system and a small solar panel array. Keith and the team were really helpful and friendly throughout and although there were a few hiccups and delays for various reasons, they kept communicating with me which really helped, until it was all completed. A few months after the installation I had some concerns about the system and Keith was again incredibly helpful and supportive to make sure it was all resolved. I wouldn't hesitate to use them again.",
  },
  {
    name: "Colin Freeman",
    month: "August",
    year: 2023,
    title: "Can only highly recommend this company",
    text: "Can only highly recommend this company. Fantastic service from start to finish. All the people we have dealt with have been exceptionally helpful. Could not be happier.",
  },
];

export const GOOGLE_REVIEWS: GoogleReview[] = [
  {
    name: "Julakha B.",
    month: "December",
    year: 2025,
    text: "Hi I've had insulation done today, Ryan and Nathan were amazing. They did the work, tidied up the mess and explained the process. As I have trouble keeping heat in, hopefully now this insulation will help keep heat in. Thank you so much CRS company and the team for a wonderful service.",
  },
  {
    name: "Stephen D.",
    month: "October",
    year: 2025,
    text: "Recently had loft insulation, kitchen fan and new radiator controls fitted. All work completed within 2 days to a high standard. Workmen were fast, efficient, polite and helpful. Similarly whenever I spoke to their office staff they were both helpful and polite. I was messaged prior to each job informing me of the name and ETA of workmen. Would not hesitate to recommend.",
  },
  {
    name: "Richard W.",
    month: "September",
    year: 2025,
    text: "I cannot praise this company too highly. From first contact to completion of the work the whole experience was perfect. People turned up when they were supposed to and were all friendly, good-humoured and respectful, and they knew what they were doing. All three teams that carried out the work were well coordinated and efficient. And they all cleared up after them! Great coordination between the office and the survey and work teams. If only every company was like this. I wish them all the best!",
  },
  {
    name: "Jennifer W.",
    month: "July",
    year: 2025,
    text: "Had a very good experience with CRS, they were very helpful in the process of things and the workmen who did the job of boiler, attic insulation and fans were very professional, friendly and on time. Cleaned up after themselves with no mess left and were very helpful. Would definitely recommend this firm to anyone.",
  },
  {
    name: "Liz S.",
    month: "February",
    year: 2025,
    text: "We had cavity wall insulation done which has made a big difference to our house. Our rooms were cold and we had some mould in corners of the rooms. Since having it done there hasn't been any. House warms up quicker and stays warmer longer. So glad we had it done and it was quick and easy. CRS were lovely and I would recommend them to anyone.",
  },
  {
    name: "T. Elliott",
    month: "February",
    year: 2025,
    text: "I had a few doubts after receiving a letter from Home Grant Check offering free services if eligible. However, after the initial call, the whole process went smoothly. The team was both professional and helpful, providing constant updates. We also needed the work to be completed fairly quickly due to our circumstances, and they were able to accommodate this. I would recommend them for future work. Thanks again!",
  },
  {
    name: "Abbie W.",
    month: "November",
    year: 2024,
    text: "Amazing from start to finish! Couldn't recommend enough.",
  },
  {
    name: "Cerianne E.",
    month: "November",
    year: 2024,
    text: "Very professional, everyone I spoke to or came in contact with. Workmen left my home clean and tidy. I would recommend them.",
  },
  {
    name: "Julie J.",
    month: "September",
    year: 2024,
    text: "I spoke to this company about having a grant as I own my home and have a lot of damp in lots of the rooms. They sent a survey person to look at my house, said it's ok I can get the grant as we meet the criteria.",
  },
];
